/**
 * @fileoverview added by tsickle
 * Generated from: util/datetime/index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as moment from 'moment-timezone';
import { Duration, humanReadableDurationString } from './duration';
/** @type {?} */
export var MON = 'Monday';
/** @type {?} */
export var TUE = 'Tuesday';
/** @type {?} */
export var WED = 'Wednesday';
/** @type {?} */
export var THU = 'Thursday';
/** @type {?} */
export var FRI = 'Friday';
/** @type {?} */
export var SAT = 'Saturday';
/** @type {?} */
export var SUN = 'Sunday';
/** @type {?} */
export var DAYS_OF_WEEK = [MON, TUE, WED, THU, FRI, SAT, SUN];
/** @type {?} */
export var SECONDS_IN_HOUR = 3600;
/** @type {?} */
export var ISO_DATETIME_FORMAT = moment.ISO_8601;
/** @type {?} */
export var DATE_FORMAT = 'YYYY-MM-DD';
/** @type {?} */
export var DATE_STR_FORMAT = 'ddd DD MMM';
/** @type {?} */
export var DATE_STR_FORMAT_WITH_YEAR = 'ddd DD MMM YYYY';
/** @type {?} */
export var DATE_FULL_STR_FORMAT = 'dddd Do MMMM';
/** @type {?} */
export var TIME_FORMAT = 'HH:mm:ss';
/** @type {?} */
export var TIME_FORMAT_HOURS = 'HH:mm';
/**
 * @param {?} date
 * @return {?}
 */
export function dayOfWeek(date) {
    return date.isoWeekday() - 1;
}
/**
 * @param {?} index
 * @return {?}
 */
export function getDayOfWeekName(index) {
    if (typeof index !== 'number') {
        index = dayOfWeek(index);
    }
    return DAYS_OF_WEEK[index];
}
/**
 * Return the given string or datetime as a date.
 * For datetimes we create a new moment, as this will be represented in UTC.
 * @param {?} obj
 * @param {?=} format
 * @return {?}
 */
export function toDate(obj, format) {
    if (format === void 0) { format = DATE_FORMAT; }
    if (typeof obj === 'string') {
        if (obj.toLowerCase() === 'today') {
            return moment.utc().startOf('day');
        }
        if (obj.toLowerCase() === 'tomorrow') {
            return moment.utc().startOf('day').add(1, 'days');
        }
        return moment.utc(obj, format);
    }
    else {
        /** @type {?} */
        var offset = moment.parseZone(obj);
        return moment.utc({
            year: offset.get('year'),
            month: offset.get('month'),
            date: offset.get('date')
        });
    }
}
/**
 * @param {?} date
 * @return {?}
 */
export function dateToStr(date) {
    return date.format(DATE_FORMAT);
}
/**
 * Returns a naive representation of the time.
 * NOTE: In almost all circumstances, you should instead use TimeService.now()
 * @return {?}
 */
export function nowNaive() {
    return moment();
}
/**
 * Returns a naive representation of the date.
 * NOTE: In almost all circumstances, you should instead use TimeService.today()
 * @return {?}
 */
export function todayNaive() {
    return toDate(nowNaive());
}
/**
 * Return a string representation of the current day.
 * If the day is today, "Today" is returned instead (see TimeService.today())
 * @param {?} date
 * @param {?=} today
 * @param {?=} withYear
 * @return {?}
 */
export function dateToReadableStr(date, today, withYear) {
    if (withYear === void 0) { withYear = false; }
    if (!date) {
        return '';
    }
    if (today && date.isSame(today)) {
        return 'Today';
    }
    return date.format(withYear ? DATE_STR_FORMAT_WITH_YEAR : DATE_STR_FORMAT);
}
/**
 * Return a string representation of the current day, date, month.
 * @param {?} date
 * @return {?}
 */
export function dayDateToReadableStr(date) {
    return date.format(DATE_STR_FORMAT);
}
/**
 * Convert the given moment to the Europe/London timezone.
 * @param {?} input
 * @return {?}
 */
export function toLocal(input) {
    return moment.tz(input, 'Europe/London');
}
/**
 * @param {?} time
 * @return {?}
 */
export function timeToReadableStr(time) {
    return time.format(TIME_FORMAT_HOURS);
}
/**
 * @param {?} input
 * @return {?}
 */
export function toTime(input) {
    /** @type {?} */
    var str = typeof input === 'string' ? input : input.format(TIME_FORMAT);
    return moment.utc("1970-01-01T" + str + ".000Z");
}
/**
 * @param {?} dateMoment
 * @param {?} timeMoment
 * @param {?=} tzOffset
 * @return {?}
 */
export function combine(dateMoment, timeMoment, tzOffset) {
    if (tzOffset === void 0) { tzOffset = 0; }
    return dateMoment
        .clone()
        .set({
        hour: timeMoment.get('hour'),
        minute: timeMoment.get('minute'),
        second: timeMoment.get('second'),
        milliseconds: timeMoment.get('milliseconds')
    })
        .utcOffset(tzOffset, true);
}
/**
 * @param {?} input
 * @return {?}
 */
export function toMoment(input) {
    return moment(input);
}
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
export function min(a, b) {
    return moment.min(a, b);
}
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
export function max(a, b) {
    return moment.max(a, b);
}
/**
 * @param {?} date
 * @param {?} days
 * @return {?}
 */
export function addDaysToDate(date, days) {
    return date.clone().add(days, 'day');
}
/**
 * @param {?} date
 * @param {?} days
 * @return {?}
 */
export function subtractDaysFromDate(date, days) {
    return date.clone().subtract(days, 'day');
}
/**
 * @param {?} firstDate
 * @param {?} secondDate
 * @return {?}
 */
export function durationBetween(firstDate, secondDate) {
    /** @type {?} */
    var diffMS = secondDate.diff(firstDate, 'milliseconds');
    return new Duration({ milliseconds: diffMS });
}
/**
 * @param {?} firstDate
 * @param {?} secondDate
 * @return {?}
 */
export function durationBetweenToReadableString(firstDate, secondDate) {
    return humanReadableDurationString(durationBetween(firstDate, secondDate));
}
/**
 * Get the next instance of weekday occurring `count` times
 * eg. "in 2 Fridays time from today" -> addWeekDays(5, 2)
 * @param {?} targetWeekday
 * @param {?} count How many weekdays of type targetWeekday to add
 * @return {?}
 */
export function addWeekDays(targetWeekday, count) {
    /** @type {?} */
    var todayDay = moment().isoWeekday();
    if (todayDay <= targetWeekday) {
        return moment()
            .isoWeekday(targetWeekday)
            .add(count - 1, 'weeks');
    }
    else {
        return moment().add(count, 'weeks').isoWeekday(targetWeekday);
    }
}
/**
 * @param {?} when
 * @param {?=} relativeTo
 * @return {?}
 */
export function getWeeksAheadReadable(when, relativeTo) {
    if (!relativeTo) {
        relativeTo = todayNaive();
    }
    if (!when.isSameOrAfter(relativeTo)) {
        return '';
    }
    relativeTo = relativeTo.startOf('isoWeek');
    /** @type {?} */
    var daysBetween = when.diff(relativeTo, 'days');
    /** @type {?} */
    var weeks = daysBetween / 7;
    if (weeks < 1) {
        return '';
    }
    if (weeks < 2) {
        return 'next week';
    }
    weeks = Math.floor(weeks);
    return 'in ' + weeks + ' weeks';
}
/**
 * @param {?} date
 * @return {?}
 */
export function nextMonday(date) {
    return date.clone().add(7, 'days').startOf('isoWeek');
}
export { Duration, humanReadableDurationString };
